import {ReactNode} from "react";
import type {UnnormalizedProps as UnnormalizedStyleProps} from '@yosmanyga/core-style'
import {WithTheme} from '@yosmanyga/theme'
import {NonExistentPrimitiveError, usePrimitives} from '@yosmanyga/primitive-ui-spec'

type ModalProps = {
    onClose: () => void,
    children: ReactNode,
}

const Modal = ({
    onClose,
    children,
    ...props
}: ModalProps) => {
    const {Modal: BaseModal} = usePrimitives()

    if (!BaseModal) {
        throw new NonExistentPrimitiveError('Modal')
    }

    return <BaseModal
        onClose={onClose}
        {...props}
    >
        {children}
    </BaseModal>
}

const ModalWithTheme = (props: ModalProps & UnnormalizedStyleProps) => <WithTheme
    {...props}
    identifier='modal'
    Component={Modal}
/>

export default ModalWithTheme
